import React, { useState } from 'react';
import { Nav, Button } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGauge, faCog, faBars, faXmark } from '@fortawesome/free-solid-svg-icons';
import useScreenSize from '../../hooks/useScreenSize';
import './Sidebar.scss';

const Sidebar = () => {
  const location = useLocation();
  const { isDesktop, isLargeDesktop } = useScreenSize();
  const [isOpen, setIsOpen] = useState(false);

  const isPermanent = isDesktop || isLargeDesktop;

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      {/* Mobile Header - Only visible on tablet/mobile */}
      {!isPermanent && (
        <div className="mobile-header">
          <div className="header-content">
            <Button 
              className="sidebar-toggle"
              onClick={toggleSidebar}
              style={{backgroundColor: 'gray', border: 'none'}}
            >
              <FontAwesomeIcon icon={isOpen ? faXmark : faBars} />
            </Button>
            <h3>Client Harbor</h3>
          </div>
        </div>
      )}

      {/* Sidebar */}
      <div className={`sidebar ${!isPermanent ? 'slideable' : ''} ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <h3>Client Harbor</h3>
          {!isPermanent && (
            <Button 
              className="close-button"
              onClick={toggleSidebar}
              variant="link"
            >
              <FontAwesomeIcon icon={faXmark} />
            </Button>
          )}
        </div>
        <Nav className="flex-column sidebar-nav">
          <Nav.Item>
            <Nav.Link 
              as={Link} 
              to="/dashboard"
              className={location.pathname === '/dashboard' ? 'active' : ''}
              onClick={() => !isPermanent && setIsOpen(false)}
            >
              <FontAwesomeIcon icon={faGauge} className="me-2" />
              Dashboard
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link 
              as={Link} 
              to="/settings"
              className={location.pathname === '/settings' ? 'active' : ''}
              onClick={() => !isPermanent && setIsOpen(false)}
            >
              <FontAwesomeIcon icon={faCog} className="me-2" />
              Settings
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </div>

      {/* Overlay for tablet/mobile */}
      {!isPermanent && isOpen && (
        <div className="sidebar-overlay" onClick={toggleSidebar} />
      )}
    </>
  );
};

export default Sidebar; 